// import mixpanel class from the library
import mixpanel from 'mixpanel-browser'
 
let env_check = process.env.NODE_ENV === "development"; 

// create an instance Mixpanel object using your project token
mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, {
    persistence: "localStorage",
    debug: env_check,
    track_pageview: "full-url"
});

let actions = {
    identify: (id) => {
      mixpanel.identify(id);
    },
    alias: (id) => {
      mixpanel.alias(id);
    },
    track: (name, props) => {
        mixpanel.track(name, props);
    },
    people: {
      set: (props) => {
        mixpanel.people.set(props);
      },
    },
    track_pageview: (pagename) => {
        mixpanel.track_pageview(pagename)
    }
  };

  export let Mixpanel = actions;